import cx from 'classnames';
import React, { useEffect, useRef } from 'react';

interface IProps {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  id?: string;
}

function Heading({ as, className, id, ...otherProps }: IProps) {
  const ref = useRef<HTMLHeadingElement>();

  useEffect(() => {
    const element = ref.current;
    const cleanHash = window.location.hash.slice(1);

    // If we have an `id`, and the `hash` matches it, scroll to the element.
    if (element && id && cleanHash === id) {
      element.scrollIntoView();
    }
  }, [id]);

  return React.createElement(as, {
    ref,
    className,
    id,
    ...otherProps,
  });
}

export const H1 = ({ className, ...otherProps }: any) => (
  <Heading
    as="h1"
    className={cx('font-ubuntu font-medium text-36', className)}
    {...otherProps}
  />
);

export const H2 = ({ className, ...otherProps }: any) => (
  <Heading
    as="h2"
    className={cx('font-ubuntu font-medium text-30', className)}
    {...otherProps}
  />
);

export const H3 = ({ className, ...otherProps }: any) => (
  <Heading
    as="h3"
    className={cx('font-ubuntu font-medium text-24', className)}
    {...otherProps}
  />
);

export const H4 = ({ className, ...otherProps }: any) => (
  <Heading
    as="h4"
    className={cx('font-ubuntu font-medium text-18', className)}
    {...otherProps}
  />
);
